<template>
  <section class="content">
      <div class="box box-info">
          <Toast style="margin-top: 35px" />
          <DataTable :value="inquiryList" :paginator="true" :rows="8"
          class="p-datatable-responsive p-datatable-customers" data-key="id">
          <!-- <Column header="S.N" field=""/> -->
          <Column header="Name" field="name"/>
          <Column header="Email" field="email"/>
          <Column header="Company Name" field="companyName"/>
          <Column header="Phone Number" field="phoneNumber"/>
          <Column header="Subject" field="subject"/>
          <Column header="Message" field="message"/>
          <Column header="Remarks" field="response"/>
          <Column header="Action" >
            <template #body="slotProps">
              <Button type="button" class="btn btn-success" @click ="openRemarksDialog(slotProps.data)">
                <i class="fa fa-edit"/>
              </Button>
           </template>
          </Column>
        </DataTable>
        <form>
          <Dialog header="Update Inquiry" :visible.sync="showDialog" :style="{width: '50vw'}" :modal="true" :closable="false"
          :contentStyle="{'overflow': 'visible'}">
          <div class="col-md-6">
            <label>Inquiry Remarks:</label>
            <textarea v-model="response" class="form-control" rows="10" cols="10"/>
          <div>
            <Button style="margin-top:5px" type="button" class="btn btn-primary" @click ="updateInquiry">
              Update
            </Button>
            <Button style="margin-top:5px" type="button" class="btn btn-danger" @click ="cancelInquiry">
              Cancel
            </Button>
          </div>
        </div>
          </Dialog>
        </form>
      </div>
  </section>
</template>
<script>
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Toast from 'primevue/toast'
import Dialog from 'primevue/dialog'

export default {
  name: 'inquiry',
  data() {
    return {
      showDialog: false,
      response: '',
      inquiryId: null
    }
  },
  computed: {
    inquiryList() {
      return this.$store.state.admin.inquiryList
    }
  },
  mounted() {
    this.customerInquiryList()
  },
  methods: {
    async customerInquiryList() {
      await this.$store.dispatch('inquiryList')
    },
    openRemarksDialog(data) {
      this.showDialog = true
      this.response = data.response
      this.inquiryId = data.id
    },
    cancelInquiry() {
      this.showDialog = false
      this.response = ''
    },
    async updateInquiry() {
      let data = {
        id: this.inquiryId,
        response: this.response
      }
      let response = await this.$store.dispatch('updateInquiry', data)
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
      }
      this.showDialog = false
    }
  },
  components: {
    Column,
    DataTable,
    Toast,
    Dialog
  }
}
</script>



// WEBPACK FOOTER //
// inquiry.vue?0d85e742